var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"white-space":"nowrap"}},[_c('b',[_vm._v(" years:")]),_c('b-form-select',{staticStyle:{"border":"1px solid gray","width":"auto","margin-left":"2px"},attrs:{"options":_vm.options},model:{value:(_vm.y1),callback:function ($$v) {_vm.y1=$$v},expression:"y1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }